var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticStyle: { overflow: "hidden" } },
    [
      _vm.loading
        ? _c("v-progress-linear", {
            staticClass: "my-0",
            attrs: { indeterminate: "", color: "blue" },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.hasError
        ? _c(
            "v-alert",
            {
              staticClass: "py-1 ma-0",
              attrs: {
                outline: "",
                color: "warning",
                icon: "assessment",
                value: "true",
              },
            },
            [
              _c("div", { staticClass: "primary--text" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.errorMessage || "There's no graph data available."
                    ) +
                    "\n    "
                ),
              ]),
            ]
          )
        : _c("div", { attrs: { id: _vm.id } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }